import React from 'react';

import { formatDurationShort } from '@neptune/shared/common-util';

import { PropertyRow } from 'components/layouts/rows';
import type { IntegerAttribute } from 'domain/experiment/attribute';

type MonitoringTimeRendererProps = {
  attribute?: IntegerAttribute;
  labelWidth?: string;
  label?: string;
  'data-name'?: string;
  rowVariant?: 'compact' | 'default';
};

export const MonitoringTimeRenderer: React.FC<MonitoringTimeRendererProps> = ({
  attribute,
  labelWidth = '100px',
  label,
  'data-name': dataName,
  rowVariant = 'default',
}) => {
  if (!attribute) {
    return null;
  }

  const monitoringTime = attribute.value;

  return (
    <PropertyRow
      value={formatDurationShort(monitoringTime / 60)}
      labelWidth={labelWidth}
      label={label}
      data-name={dataName}
      variant={rowVariant}
    />
  );
};
